import * as config from '../config.js';
import { init_datalayer, push_utag_data } from '../init.js';
import { cache_handler } from '../util.js';

import $ from 'jquery';

// ===========================================================================
// Globals
// ===========================================================================

// Module name
export const MODULE_NAME = 'datalayer_product';

// Re-exports
export let global_vars = {};

// Datalayer values
export const PRODUCT = {
    list_position: [],
    list_name: [],
    category: [],
    id: [],
    name: [],
    variant: [],

    promo_id: [],
    promo_name: [],
    promo_creative: [],
    promo_position: [],

    // These are not added to utag_data
    price: [],
    quantity: [],
    brand: [],
    vendor: [],
    sku: [],
};

// ===========================================================================
// Product datalayer handlers
// ===========================================================================

function product_price_handler(utag_data) {
    $('input').on('inputchange', function() {
        let val = this.value;

        // TODO: should this be in this function?
        // Set form input value
        $('#donateForm > input.donationAmount').text(val);

        // Set value
        utag_data['impression_price'] = val;
        utag_data['product_price'] = val;
    });
}

function product_type_handler(utag_data) {
    $('#sg_radio, #mp_radio, #yr_radio').change(function() {
        if (this.value.toLowerCase() === 'sg') {
            utag_data['impression_brand'] = 'One Time Donation';
            utag_data['product_brand'] = 'One Time Donation';
        } else if (this.value.toLowerCase() === 'yr') {
            utag_data['impression_brand'] = 'Yearly Pledge';
            utag_data['product_brand'] = 'Yearly Pledge';
        } else {
            utag_data['impression_brand'] = 'Pledge';
            utag_data['product_brand'] = 'Pledge';
        }
    });
}

// ===========================================================================
// Product data layer
// ===========================================================================

// global is the window object when in the browser context
// this function should be called only after init_data() function is called
function update_data(global, utag_data, url, title) {
    // url should be the value of window.location.href
    // title should be the value of document.title

    // These were not in the new document, so we're keeping
    // them around in case they're still being used.
    utag_data['page_url'] = url;
    utag_data['device_type'] = config.DEVICE.device;
    utag_data['product_position'] = PRODUCT.list_position;
    utag_data['product_sku'] = PRODUCT.id;
    utag_data['product_list'] = PRODUCT.list_name;

    // These carried over from the old code
    utag_data['impression_id'] = PRODUCT.id;
    utag_data['impression_sku'] = PRODUCT.id;
    utag_data['impression_category'] = PRODUCT.category;
    utag_data['impression_name'] = PRODUCT.name;
    utag_data['impression_position'] = PRODUCT.list_position;
    utag_data['impression_list'] = PRODUCT.list_name;
    utag_data['page_type'] = 'product';
    utag_data['page_name'] = title;
    utag_data['product_id'] = PRODUCT.id;
    utag_data['product_category'] = PRODUCT.category;
    utag_data['product_name'] = PRODUCT.name;

    // New
    // I don't think donation products have variants.
    // So I think this will always be empty
    utag_data['product_variant'] = PRODUCT.variant;
    utag_data['page_category_sbu'] = 'ODN';
    utag_data['enh_action'] = 'detail';

    // These will always be empty arrays, cause donation products
    // will never be considered promotions
    utag_data['promo_imp_ids'] = PRODUCT.promo_id;
    utag_data['promo_imp_names'] = PRODUCT.promo_name;
    utag_data['promo_imp_creatives'] = PRODUCT.promo_creative;
    utag_data['promo_imp_positions'] = PRODUCT.promo_position;

    push_utag_data(utag_data);
}

function init_handlers(global, data) {
    // Setup data layer handlers
    cache_handler(global);
    product_price_handler(data.utag_data);
    product_type_handler(data.utag_data);
}

// global is the window object when in the browser context this function should
export function initialize(global) {
    init_datalayer(global, init_handlers, update_data);
}

// ===========================================================================
//
// ===========================================================================
